import GhostCard from './GhostCard';

export default GhostCard;
